var map = {
	"./Image_Lobby_Copyright_HotellerieSuisse.jpg": "749c",
	"./ahv-logo.jpg": "d6a2",
	"./bg01.png": "aceb",
	"./bg02.png": "4bb4",
	"./bg03.png": "4d27",
	"./de.png": "a46d",
	"./fr.png": "d321",
	"./logo-hs.svg": "c78f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";